import { defineStore } from "pinia";
import { useUserStore } from "./user";

const STATS_URL =
  "https://2vta0zknch.execute-api.us-east-1.amazonaws.com/beta/openrate-v2/";

export const useStatsStore = defineStore("stats", {
  state: () => {},

  actions: {
    async sendToStatsService(params) {
      const url = new URL(STATS_URL);
      Object.keys(params).forEach((key) => {
        url.searchParams.append(key, params[key]);
      });
      const dataRequest = {
        method: "GET",
      };
      let response = await fetch(url, dataRequest);
    },
  },
});
